import '../Main.css';

import React, { useState } from 'react';

import { images } from "../../../../constants";
import FeatureContent from './FeatureContent';

const features = [
  {
    key: 'blockchain-wallet',
    order: 1,
    buttonLabel: 'Blockchain wallet',
    title: 'Blockchain wallet',
    subtitle: 'Add & view',
    description: 'your wallets by syncing them directly from the blockchain',
    image: images.journaler.main.blockchainBG,
    contents: [
      {
        title: null,
        checkList: [
          'Sync directly from the blockchain',
          'CSV Exports with FIAT conversion',
          'View transactions and wallet balances'
        ]
      }
    ]
  },
  {
    key: 'imported-wallet',
    order: 2,
    buttonLabel: 'Imported wallet',
    title: 'Imported wallet',
    subtitle: 'Manually import',
    description: 'all of your transaction data',
    image: images.journaler.main.importedWalletBG,
    contents: [
      {
        title: null,
        checkList: [
          'Supporting all known currencies, 20,000+',
          'Easy to follow CSV Import template provided',
          'Import wallet transaction data via our integrations'
        ]
      }
    ]
  },
  {
    key: 'accounting-system',
    order: 3,
    buttonLabel: 'Accounting system',
    title: 'Accounting system',
    subtitle: 'Connect',
    description: 'to your existing accounting systems',
    image: images.journaler.main.accountingSystemBG,
    contents: [
      {
        title: null,
        checkList: [
          'Set up Xero & QuickBooks integration',
          'Track crypto transactions in crypto and FIAT',
          'Bank feeds: set up automated transaction feed (set as open or reconciled)',
          'Invoice and bill exports as draft, open or settled',
          'Journals (CGT) calculate tax liabilities',
          'Journals (Wallet Balance) report holdings'
        ]
      }
    ]
  },
  {
    key: 'imports-export',
    order: 4,
    buttonLabel: 'Imports & export',
    title: 'Imports & export',
    subtitle: 'Easy',
    description: 'import & export',
    image: images.journaler.main.importExportBG,
    contents: [
      {
        title: 'Data import',
        checkList: [
          'Blockchain wallet data sync',
          'Spreadsheets import',
          'Custom spreadsheets import',
          'Set up Coinbase & Binance integration'
        ]
      },
      {
        title: 'Data export',
        checkList: [
          'Convert transaction data into $ value',
          'Capture transaction descriptions and wallet addresses',
          'Export into accounting systems'
        ]
      }
    ]
  },

  {
    key: 'cgt-tax-calculator',
    order: 5,
    buttonLabel: 'CGT tax calculator',
    title: 'CGT tax calculator',
    subtitle: 'Calculate CGT tax',
    description: 'for every single transaction',
    image: images.journaler.main.CGTTaxCalculatorBG,
    contents: [
      {
        title: 'Comprehensive customisation abilities',
        checkList: [
          'Editable tax rate',
          'Predefined financial periods',
          'Set by country of origin'
        ]
      },
      {
        title: 'Reporting',
        checkList: [
          'FIFO, LIFO, HIFO, ACB',
        ]
      }
    ]
  },
  {
    key: 'aml-check',
    order: 6,
    buttonLabel: 'AML check',
    title: 'AML(Anti Money Laundering) check',
    subtitle: 'Seamless',
    description: 'transaction monitoring & risk alerts',
    image: images.journaler.main.AMLCheck,
    contents: [
      {
        title: null,
        checkList: [
          'Automatic transaction and wallet sync.',
          'Screens selected transactions for AML risks periodically.',
          'Risk flagging with a full audit trail available upon request.',
          'A full AML report including end-to-end transaction tracing, incident (hack) reporting, and investigation of lost funds.'
        ]
      }
    ]
  },
]

const OurFeatures = () => {
  const [feature, setFeature] = useState(1)
  const selectedFeature = features.find(item => item.order === feature)

  return (
    <div className='container' style={{ paddingTop: '45px' }}>
      <div className='d-flex flex-column' style={{ gap: '55px' }}>
        <div className='titleOurFeatures text-center'>Our Features</div>
        <div className='feature-buttons-container'>
          {features.map((item) => (
            <a
              key={item.key}
              className={`btn feature-btn txt-nowrap ${feature === item.order ? 'selectedFeature' : 'whiteBorderBottom'}`}
              onClick={() => setFeature(item.order)}
            >
              {item.buttonLabel}
            </a>
          ))}
        </div>
        <div className='bg-main' style={{ margin: '0 17px' }}>
          {selectedFeature && <FeatureContent
            title={selectedFeature.title}
            subtitle={selectedFeature.subtitle}
            description={selectedFeature.description}
            image={selectedFeature.image}
            contents={selectedFeature.contents}
          />}
        </div>
      </div>
    </div>
  )
};
export default OurFeatures;
